// import { Loader } from "@googlemaps/js-api-loader";
import {READY_GATE} from '@/services/bootstrap';

export default function mapServiceFactory(services) {
  let thisService = {
    initAsync,
    getPlaceFromStringAsync,
    getPlaceFromAddressAsync,
    getAddress,
    getPlaceOptionsAsync,
    getPlaceDetailsAsync,
    validatePrintOSAddress,
    getPlaceFromBrowserAsync,
    _initCallback,
  };

  let loader;
  let placesService;
  let autoCompleteService;
  let loaded = false;

  return thisService;

  ////////////////////
  async function initAsync() {
    loaded = false;
    let apiKey =  services.session.getRegistryValue('mapsKey');
    if (window.location.host.endsWith('.cn') || !apiKey) {
      //services.bootstrap.readyGateCleared(READY_GATE.map);
      return Promise.resolve();
    }


    let scriptElement = services.document.createElement('script');
    scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&callback=$printos.address.vx._initCallback`;
    // scriptElement.setAttribute('async', null);
    services.document.head.appendChild(scriptElement);
  }

  async function _initCallback() {
    await window.google.maps.importLibrary('places');
    placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
    autoCompleteService = new window.google.maps.places.AutocompleteService();
    //services.bootstrap.readyGateCleared(READY_GATE.map);
    loaded = true;

    // navigator.geolocation.getCurrentPosition(success, failure);
  }

  // function success(pos) {
  //   console.log('Success', pos);
  // }
  //
  // function failure(err) {
  //   console.log('Failure', err);
  // }
  // async function initAsync() {
  //   return new Promise((resolve, reject) => {
  //     loaded = false;
  //     let apiKey =  services.session.getRegistryValue('mapsKey');
  //     if (window.location.host.endsWith('.cn') || !apiKey) {
  //       //services.bootstrap.readyGateCleared(READY_GATE.map);
  //       resolve();
  //       return;
  //     }
  //
  //     loader = new Loader({
  //       apiKey: apiKey,
  //       version: 'weekly',
  //     });
  //
  //     loader.load().then(async () => {
  //       await window.google.maps.importLibrary('places');
  //       placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
  //       autoCompleteService = new window.google.maps.places.AutocompleteService();
  //       //services.bootstrap.readyGateCleared(READY_GATE.map);
  //       loaded = true;
  //       resolve();
  //     });
  //   });
  // }

  function getPlaceFromStringAsync(query, details = false) {
    return new Promise((resolve, reject) => {
      placesService.findPlaceFromQuery({
        query,
        fields: ['name', 'geometry', 'place_id', 'formatted_address'],
      }, (results, status) => {
        // console.log('getPlaceFromStringAsync1', query, results, status);
        if (!results || results.length === 0) {
          resolve(null);
          return;
        }

        let result = results[0];
        if (details) {
          return getPlaceDetailsAsync(result).then(place => {
            resolve(place);
          });
        }
        else {
          resolve(result);
        }
      });
    });
  }

  function getTimeZoneFromPlaceAsync(place) {
    let config = {
      // headers: {
      //   'If-Modified-Since': undefined,
      //   'Cache-Control': undefined
      // },
      method: 'GET',
      url: 'https://maps.googleapis.com/maps/api/timezone/json',
      credentials: 'omit',
      params: {
        key: services.session.getRegistryValue('mapsKey'),
        timestamp: new Date().getTime() / 1000,
        location: place.geometry.location.lat() + ',' + place.geometry.location.lng(),
      }
    };

    return services.http.fetch('https://maps.googleapis.com/maps/api/timezone/json', config).then(resp => {
      return resp.data?.timeZoneId;
    });
  }

  function getPlaceFromAddressAsync(address, details = false) {
    let query = '';
    if (address.addressLine1) { query += `${address.addressLine1} `; }
    if (address.addressLine2) { query += `${address.addressLine2} `; }
    if (address.locality) { query += `${address.locality} `; }
    if (address.region) { query += `${address.region} `; }
    if (address.postalCode) { query += `${address.postalCode} `; }
    if (address.country) { query += `${address.country} `; }

    return getPlaceFromStringAsync(query, details);
  }

  function getPlaceFromBrowserAsync() {
    if (!('geolocation' in window.navigator)) {
      return Promise.reject();
    }

    return new Promise((resolve, reject) => {
      window.navigator.geolocation.getCurrentPosition(position => {
        let defaultLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({'latLng': defaultLocation}, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
            getPlaceFromStringAsync(results[0].formatted_address, true).then(place => {
              resolve(place);
            });
          }
        });
      }, error => {
        console.error('Failed to get location');
        reject();
      }, {timeout: 5000});
    });
  }

  function getPlaceDetailsAsync(place) {
    return new Promise((resolve, reject) => {
      return placesService.getDetails({
        placeId: place.place_id,
        fields: ['address_components', 'timezone']
      }, (details, status) => {
        // console.log('getPlaceFromStringAsync Details', details, status);
        return getTimeZoneFromPlaceAsync(place).then(timezone => {
          let updatedPlace = {...place, ...details};
          updatedPlace.timezone = timezone;
          resolve(updatedPlace);
        });
      });
    });
  }

  function getAddress(place) {
    if (!place.address_components) {
      return null;
    }

    let address = {};

    // Address1
    let streetAddress = _getAddressComponent(place, 'street_address');
    if (streetAddress) {
      address.addressLine1 = streetAddress.trim();
    }
    else {
      let streetNumber = _getAddressComponent(place, 'street_number');
      let route = _getAddressComponent(place, 'route');
      if (streetNumber || route) {
        address.addressLine1 = '';
      }

      if (streetNumber) {
        address.addressLine1 += ` ${streetNumber.long_name}`;
        address.addressLine1 = address.addressLine1.trim();
      }

      if (route) {
        address.addressLine1 += ` ${route.long_name}`;
        address.addressLine1 = address.addressLine1.trim();
      }
    }

    // Address2
    let floor = _getAddressComponent(place, 'floor');
    let room = _getAddressComponent(place, 'room');
    let box = _getAddressComponent(place, 'box');
    let subpremise = _getAddressComponent(place, 'subpremise');
    if (floor || room || box || subpremise) {
      address.addressLine2 = '';
    }

    if (floor) {
      address.addressLine2 += ` ${floor.long_name}`;
      address.addressLine2 = address.addressLine2.trim();
    }

    if (room) {
      address.addressLine2 += ` ${room.long_name}`;
      address.addressLine2 = address.addressLine2.trim();
    }

    if (box) {
      address.addressLine2 += ` ${box.long_name}`;
      address.addressLine2 = address.addressLine2.trim();
    }

    if (subpremise) {
      address.addressLine2 += ` ${subpremise.long_name}`;
      address.addressLine2 = address.addressLine2.trim();
    }

    // City/Locality
    let locality = _getAddressComponent(place, 'locality');
    if (locality) {
      address.locality = locality.long_name;
    }
    else {
      locality = _getAddressComponent(place, 'administrative_area_level_2');
      if (locality) {
        address.locality = locality.long_name;
      }
      else {
        locality = _getAddressComponent(place, 'postal_town');
        if (locality) {
          address.locality = locality.long_name;
        }
      }
    }

    // State/Region
    let region = _getAddressComponent(place, 'administrative_area_level_1');
    if (region) {
      address.region = region.short_name;
    }
    else {
      region = _getAddressComponent(place, 'sublocality');
      if (region) {
        address.region = region.short_name;
      }
      else {
        region = _getAddressComponent(place, 'sublocality_level_1');
        if (region) {
          address.region = region.short_name;
        }
      }
    }

    // Postal code
    let code = _getAddressComponent(place, 'postal_code');
    if (code) {
      address.postalCode = code.long_name;
      let codeSuffix = _getAddressComponent(place, 'postal_code_suffix');
      if (codeSuffix) {
        address.postalCode += `-${codeSuffix.long_name}`;
      }
    }

    // Country
    let country = _getAddressComponent(place, 'country');
    if (country) {
      address.country = country.short_name;
    }

    return address;
  }

  function validatePrintOSAddress(address) {
    let reasons = [];
    let isValid = true;
    if (!address.addressLine1 || address.addressLine1.trim() === '') {
      reasons.push('Address');
      isValid = false;
    }

    if (!address.locality || address.locality.trim() === '') {
      reasons.push('Locality');
      isValid = false;
    }

    if (!address.region || address.region.trim() === '') {
      reasons.push('Region');
      isValid = false;
    }

    if (address.country === 'US' || address.country === 'CA') {
      if (!address.postalCode || address.postalCode.trim() === '') {
        reasons.push('PostalCode');
        isValid = false;
      }
    }

    return {valid: isValid, reasons};
  }

  function getPlaceOptionsAsync(query) {
    return new Promise((resolve, reject) => {
      autoCompleteService.getPlacePredictions({
        input: query,
        types: ['address'],
        // fields: ['name', 'geometry', 'place_id', 'formatted_address'],
      }, (results, status) => {
        // console.log('getPlaceOptionsAsync', results, status);
        let options = [];
        if (results) {
          results.forEach(result => {
            options.push({
              display: result.description,
              value: result
            })
          });
        }

        resolve(options);
      });
    });
  }

  function _getAddressComponent(place, type) {
    if (!place.address_components) {
      return null;
    }

    let found = place.address_components.find(component => {
      return component.types.includes(type);
    });

    return found;
  }
}
